(function () {
	let swiperInstances = [];
  
	const initSlider = (slider) => {
	  const btnPrev = slider.querySelector('.multicolumn__button-prev');
	  const btnNext = slider.querySelector('.multicolumn__button-next');
	  const pagination = slider.querySelector('.multicolumn__pagination');
	  const isDesktopSlider = slider.classList.contains('swiper--multicolumn--desktop');
	  const isMobileSlider = slider.classList.contains('swiper--multicolumn--mobile');
	  const columnToShow = parseInt(slider.dataset.columnToShow, 10) || 3;
	  const columnSpacing = parseInt(slider.dataset.columnSpacing, 10) || 8;
  
	  // Destroy existing swiper if already initialized
	  if (slider.swiper) {
		slider.swiper.destroy(true, true);
	  }

	  var swiperOptions = {
		loop: false,
		breakpoints: {
		  320: {
			enabled: isMobileSlider,
			slidesPerView: 1,
			slidesPerGroup: 1,
			spaceBetween: columnSpacing,
		  },
		  640: {
			enabled: isMobileSlider,
			slidesPerView: 2,
			slidesPerGroup: 2,
			spaceBetween: columnSpacing,
		  },
		  990: {
			enabled: isDesktopSlider,
			slidesPerView: columnToShow - 0.5,
			slidesPerGroup: 1,
			spaceBetween: columnSpacing,
		  },
		  1200: {
			enabled: isDesktopSlider,
			slidesPerView: columnToShow,
			slidesPerGroup: 1,
			spaceBetween: columnSpacing,
		  },
		},
		freeMode: {
			enabled: true,
			momentum: true,
		},
		navigation: {
		  nextEl: btnNext,
		  prevEl: btnPrev,
		},
	  };

	  if (pagination) {
		swiperOptions.pagination = {
		  el: pagination,
		  clickable: true,
		};
	  }
  
	  // Initialize Swiper
	  const swiper = new Swiper(slider, swiperOptions);
  
	  slider.swiper = swiper;
	  return swiper;
	};
  
	const initMulticolumn = () => {
	  const sliders = document.querySelectorAll('.swiper--multicolumn');
  
	  // Destroy existing sliders
	  destroyAllSliders();
  
	  // Initialize sliders
	  if (sliders && sliders.length > 0) {
		swiperInstances = Array.from(sliders).map((slider) => initSlider(slider));
	  }
	};
  
	const destroyAllSliders = () => {
	  swiperInstances.forEach((swiper) => {
		if (swiper) swiper.destroy(true, true);
	  });
	  swiperInstances = [];
	};
  
	// Initialize Swipers on page load
	initMulticolumn();

	// Reinitialize on Shopify section load
	document.addEventListener('shopify:section:load', () => {
	  destroyAllSliders();
	  initMulticolumn();
	});
  
	// Handle window resize with debounce
	let resizeTimeout;
	window.addEventListener('resize', () => {
	  clearTimeout(resizeTimeout);
	  resizeTimeout = setTimeout(() => {
		destroyAllSliders();
		initMulticolumn();
	  }, 300);
	});
  })();
  



// (function () {
// 	let swiperMulticolumn;
	
// 	const initSlider = (slider) => {
// 	  const btnPrev = slider.querySelector('.multicolumn__button-prev');
// 	  const btnNext = slider.querySelector('.multicolumn__button-next');
// 	  const isDesktopSlider = slider.classList.contains('swiper--multicolumn--desktop');
// 	  const isMobileSlider = slider.classList.contains('swiper--multicolumn--mobile');
// 	  const columnToShow = slider.dataset.columnToShow ?? 3;
  
// 	  return new Swiper(slider, {
// 		loop: false,
// 		breakpoints: {
// 		  320: {
// 			enabled: isMobileSlider,
// 			slidesPerView: 1,
// 			slidesPerGroup: 1,
// 			spaceBetween: 8,
// 		  },
// 		  640: {
// 			enabled: isMobileSlider,
// 			slidesPerView: 2,
// 			slidesPerGroup: 2,
// 			spaceBetween: 8,
// 		  },
// 		  990: {
// 			enabled: isDesktopSlider,
// 			slidesPerView: columnToShow,
// 			slidesPerGroup: 1,
// 			spaceBetween: 8,
// 		  }
// 		},
// 		navigation: {
// 		  nextEl: btnNext,
// 		  prevEl: btnPrev,
// 		},
// 	  });
// 	};
  
// 	const initMulticolumn = () => {

// 		const multicolumnSection = document.querySelector(".multicolumn-section");

// 		const sectionResizeObserver = new ResizeObserver((entries) => {
			
// 			const sliders = document.querySelectorAll('.swiper--multicolumn');
			
// 			if (sliders && sliders.length > 0) {
// 				swiperMulticolumn = Array.from(sliders).map(slider => initSlider(slider));
// 			}
// 		});

// 		sectionResizeObserver.observe(multicolumnSection);

// 		// const sliders = document.querySelectorAll('.swiper--multicolumn');
		
// 		// if (sliders && sliders.length > 0) {
// 		// 	swiperMulticolumn = Array.from(sliders).map(slider => initSlider(slider));
// 		// }
// 	};
  
// 	const destroySlider = () => {
// 	  if (Array.isArray(swiperMulticolumn)) {
// 		swiperMulticolumn.forEach((swiper) => {
// 		  if (swiper) swiper.destroy(true, true);
// 		});
// 	  } else if (swiperMulticolumn) {
// 		swiperMulticolumn.destroy(true, true);
// 	  }
// 	  swiperMulticolumn = null;
// 	};
  
// 	// Initialize
// 	initMulticolumn();
  
// 	// Handle section updates
// 	document.addEventListener("shopify:section:load", function () {
// 	  destroySlider();
// 	  initMulticolumn();
// 	});
//   })();